import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import I18n from 'i18n-js';
import cx from 'classnames';
import formatCurrency from 'common/utils/format-currency';
import calcPrice from 'common/utils/calc-price';
import { getQuoteAmountDefaultTextFromCurrencyCode } from 'helper/quote';
import styles from '../styles.less';

const DiscountFee = ({ delivery }) => {
  const discount = _get(delivery, 'quote.discount');
  if (!discount) {
    return null;
  }
  const name = _get(discount, 'name');
  const amount = _get(discount, 'discountAmount', 0);
  const currency = _get(delivery, 'quote.currency');
  const code = _get(currency, 'code');
  const priceTag =
    amount > 0
      ? `-${formatCurrency({ code, amount: calcPrice(amount, currency) })}`
      : getQuoteAmountDefaultTextFromCurrencyCode(code);
  return (
    <div className={styles.quote}>
      <span>
        {I18n.t('v2.homepage.manualOrder.heading.offer', {
          name,
        })}
      </span>
      <span className={cx(styles.priceTag, styles.discountTag)}>
        {priceTag}
      </span>
    </div>
  );
};

DiscountFee.propTypes = {
  delivery: PropTypes.shape({}).isRequired,
};

export default DiscountFee;
